class Tabs extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('.tab');
        this.contents = this.querySelectorAll('.tab-content');
        this.initTabs();
        this.loadLastSelectedTab();
    }

    initTabs() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                this.tabs.forEach(t => t.classList.remove('active'));
                this.contents.forEach(c => c.classList.remove('active'));

                localStorage.setItem('selectedTab', tab.dataset.tab);

                document.querySelectorAll('custom-tabs').forEach(element => {
                    element.updateTabs(tab.dataset.tab);
                });
            });
        });

        if (this.tabs.length > 0) {
            this.tabs[0].classList.add('active');s
            this.contents[0].classList.add('active');
        }
    }

    loadLastSelectedTab() {
        const lastSelectedTab = localStorage.getItem('selectedTab');
        if (lastSelectedTab) {
            this.updateTabs(lastSelectedTab);
        }
    }

    updateTabs(tab) {
        this.tabs.forEach(t => t.classList.remove('active'));
        this.contents.forEach(c => c.classList.remove('active'));

        const selectedTab = this.querySelector(`.tab-${tab}`);

        if (selectedTab) {
          selectedTab.classList.add('active');
          this.querySelector(`.tab-content-${tab}`).classList.add('active');

          // const sectionWrapper = selectedTab.closest('section');

          // if (sectionWrapper) {
            // const urlButton = sectionWrapper.querySelector('.tabs__link');

            // if (urlButton) {
            //   const selectedTabLink = this.querySelector(`.tab-content-${tab}`).dataset.tabLink;

          //     urlButton.href = selectedTabLink;
          //   }
          // }
        }
    }
}

customElements.define('custom-tabs', Tabs);


document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('template-page.faqs')) {
    const faqFilter = document.getElementById('FaqSearch');
    const accordions = document.querySelectorAll('.faq__accordions .accordion__wrapper');
    const accordionWrappers = document.querySelectorAll('.faq__section');
    const noResults = document.querySelector('.faq__search-no-results');

    faqFilter.addEventListener("input", () => {
      let value = faqFilter.value.toLowerCase();

      accordions.forEach(function(accordion) {
        accordion.classList.toggle('hidden-block', accordion.textContent.toLowerCase().indexOf(value) == -1);
      });

      accordionWrappers.forEach((wrapper) => {
        const innerAccordions = wrapper.querySelectorAll('.accordion__wrapper');

        [...innerAccordions].some(el => !el.classList.contains('hidden-block'))
          ? wrapper.closest('.section').style.display = 'block'
          : wrapper.closest('.section').style.display = 'none';
      });

      [...accordions].every(el => el.classList.contains('hidden-block'))
        ? noResults.classList.remove('hidden-block')
        : noResults.classList.add('hidden-block');
    });
  }
});
  
  // if (!customElements.get('upsell-item')) {
  //   class UpsellItem extends HTMLElement {
  //     constructor () {
  //       super();
  
  //       this.select = this.querySelector('.upsell__variant-select');
  //       this.upsellImg = this.querySelector('.upsell__img img');
  //       this.price = this.querySelector('.upsell_price');
  //       this.comparePrice = this.querySelector('.upsell_compare_price');
  //       this.checkbox = this.querySelector('.upsell__variant-checkbox input[type=checkbox]');
  //       this.quantityInput = this.querySelector('.upsell_quantity_input');
  //       this.quantityInput?.addEventListener('change', () => {
  //         this.checkbox.setAttribute('data-quantity', this.quantityInput.value);
  //       })
  
  
  //       if(this.select) {
  //         this.select.addEventListener('change', () => {
  //           if(this.querySelector('.product-variant-id')) {
  //             this.querySelector('.product-variant-id').value = this.select.value;
  //           }
            
  //           // this.inputId.dispatchEvent(new Event('change'));
  
  //           console.log('select change', this.select.value);
  
  //           const selectedOption = this.select.options[this.select.selectedIndex];
  
  //           if(selectedOption.getAttribute('data-featuredImage')) {
  //             this.upsellImg.srcset = selectedOption.getAttribute('data-featuredImage');
  //           }
  
  //           if(selectedOption.getAttribute('data-price')) {
  //             this.price.innerText = selectedOption.getAttribute('data-price');
  //           }
  
  //           if(selectedOption.getAttribute('data-comparePrice')) {
  //             this.comparePrice.innerText = selectedOption.getAttribute('data-comparePrice');
  //           }
  //         }) 
  //       }
  //     }
  //   }
  
  //   customElements.define('upsell-item', UpsellItem);
  // }
  
  
  
  
  // if (!customElements.get('upsells-modal')) {
  //   class UpsellModal extends HTMLElement {
  //     constructor () {
  //       super();
  //     }
  
  //     connectedCallback() {
  //       const items_checkboxes = this.querySelectorAll('.upsell_main_content input.product-variant-id');
  //       console.warn('items_checkboxes', items_checkboxes);
  
  //       if(items_checkboxes.length) {
  //         const cartTextElement = this.querySelector('.upsell_modal_submit_text');
  
  //         console.warn('cartTextElement', cartTextElement);
  
  //         items_checkboxes.forEach((checkbox) => {
  //           checkbox.addEventListener('change', () => {
  //             console.warn('change event triggered', checkbox.dataset.quantity);
  //             const checkedCount = this.querySelectorAll('.upsell_main_content input.product-variant-id:checked').length;
  
  //             if (checkedCount === 0) {
  //               cartTextElement.textContent = window.upsellStrings.no_products_added;
  //             } else if (checkedCount === 1) {
  //               cartTextElement.textContent = window.upsellStrings.one_product_added;
  //             } else {
  //               cartTextElement.textContent = window.upsellStrings.multiple_products_added.replace('[count]', checkedCount);
  //             }
  //           });
  //         });
  //       }
  //     }
  //   }
  //   customElements.define('upsells-modal', UpsellModal);
  // }


class IconTooltip extends HTMLElement {
  static documentClickHandler = null;
  static tooltips = [];

  constructor() {
    super();
    this.isMobile = window.innerWidth < 768;
    IconTooltip.tooltips.push(this);

    // Set up document click handler once
    if (!IconTooltip.documentClickHandler) {
      IconTooltip.documentClickHandler = (e) => {
        IconTooltip.tooltips.forEach(tooltip => {
          const details = tooltip.querySelector('details');
          const summary = details.querySelector('summary');
          if (details.hasAttribute('open') && 
              !details.contains(e.target) && 
              !summary.contains(e.target)) {
            details.removeAttribute('open');
          }
        });
      };
      document.addEventListener('click', IconTooltip.documentClickHandler);
    }

    this.init();
  }


  init() {
    const details = this.querySelector('details');
    const summary = details.querySelector('summary');
    const content = details.querySelector('.tooltip-content');

    if (!this.isMobile) {
      // Desktop behavior
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        // Prevent the open attribute from being removed
        e.stopPropagation();
      });

      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
      });
    }

    // Handle resize
    window.addEventListener('resize', () => {
      debounce(() => {
        this.isMobile = window.innerWidth < 768;
        this.init();
      }, 300);
    });
  }
}

// Register the custom element
customElements.define('icon-tooltip', IconTooltip);